import React from 'react';
import { useLocale } from '../../hooks/useLocale';
import { useStoreActions, useStoreState } from '../../store';
import { SubtitleTextColors } from '../../typings';
import { MenuHeader } from './MenuHeader';
import { ColorOptionRow, SubmenuScreenContent } from './styles';

const textColorOptions = [
  SubtitleTextColors.White,
  SubtitleTextColors.Gray,
  SubtitleTextColors.Black,
  SubtitleTextColors.Yellow,
  SubtitleTextColors.Orange,
  SubtitleTextColors.Red,
  SubtitleTextColors.Green,
  SubtitleTextColors.Cyan,
  SubtitleTextColors.Blue,
];

export const FontColorScreen = () => {
  const locale = useLocale();
  const actions = useStoreActions((actions) => actions);
  const subtitleTextColor = useStoreState((state) => state.subtitles.subtitleTextColor);

  function handleColorClick(colorOption: SubtitleTextColors) {
    actions.subtitles.setSubtitleTextColor(colorOption);
    actions.settings.setSubtitleTextColor(colorOption);
  }

  return (
    <SubmenuScreenContent>
      <MenuHeader
        title={locale.translations.SubtitleOptions.FontColor}
        onBack={() => actions.languageMenu.navigateBack()}
      />
      {textColorOptions.map((colorOption) => (
        <ColorOptionRow
          key={colorOption}
          data-testid={`videoPlayer_subtitleColor_${colorOption}`}
          active={colorOption === subtitleTextColor}
          swatchColor={colorOption}
          onClick={() => handleColorClick(colorOption)}
        >
          {locale.translations.SubtitleOptions.TextColorOption(colorOption)}
        </ColorOptionRow>
      ))}
    </SubmenuScreenContent>
  );
};
